import { BasePublicApi } from '#packages/apilib';

import type { Scope } from './scope';
import type { Callback } from './types';

const runNextMigration = async (scope: Scope) => {
  const { store } = scope;
  const queue = store.getMigrationsQueue();
  const isRunning = store.getIsRunning();

  if (queue.length === 0 || isRunning) return;

  const { migration, resolve, reject } = queue[0];
  store.setIsRunning(true);

  try {
    const migrationResult = await migration();
    resolve(migrationResult);
  } catch (error) {
    console.error('Migration failed:', error);
    reject(error);
  } finally {
    store.removeMigrationFromQueue();
    store.setIsRunning(false);
    runNextMigration(scope);
  }
};

export const addMigrationToQueue = <ResolveType = void>(
  scope: Scope,
  migration: Callback<ResolveType>,
): Promise<ResolveType> => {
  return new Promise<ResolveType>((resolve, reject) => {
    const isRunning = scope.store.getIsRunning();
    scope.store.pushMigrationPromiseToQueue({ migration, resolve, reject });
    if (!isRunning) {
      runNextMigration(scope);
    }
  });
};

export class MigrationsManagerApi extends BasePublicApi<Scope> {
  addMigrationToQueue = this.bindScope(addMigrationToQueue);
}
